<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("user.create") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="md"
            type="neutral"
            class="btn-primary"
            @click="handleCreate"
            >{{ $t("save") }}</base-button
          >
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("user.create") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
            <div class="form-group row">
              <label for="user-name" class="col-md-2 col-form-label form-control-label">{{
                $t("user.name")
              }} *</label>
              <div class="col-md-10">
                <base-input id="user-name" placeholder="" v-model="Name"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label
                for="email"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("email") }} *</label
              >
              <div class="col-md-10">
                <base-input
                  type="email"
                  autocomplete="email"
                  placeholder=""
                  id="email"
                  v-model="Email"
                />
              </div>
            </div>

            <div class="form-group row">
              <label
                for="example-search-input"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("user.phone") }} * (66xxxxxxxxx)</label
              >
              <div class="col-md-10">
                <base-input
                  id="example-search-input"
                  placeholder=""
                  v-model="Phone"
                ></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label
                for="user-role-select"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("user.role") }} *</label
              >
              <div class="col-md-10">
                <base-input label-for="user-role-select">
                  <select
                    class="form-control"
                    id="user-role-select"
                    v-model="GroupID"
                  >
                    <option v-for="u in UserType" :key="u.id" :value="u.id">{{
                      u.name
                    }}</option>
                  </select>
                </base-input>
              </div>
            </div>

            <div class="form-group row" v-if="GroupID == 2 || GroupID == 4 " >
              <label
                for="user-corporate"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("menu.corporate") }} *</label
              >
              <div class="col-md-10">
                <base-input>
                  <el-select id="user-corporate"
                    v-model="EnterpriseID"
                    filterable
                    :placeholder="$t('menu.corporate')"
                  >
                    <el-option
                      v-for="option in corporate"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "form-elements",
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      tableData: "Auth/getData",
      corporateRaw: "Corporate/getData"
    }),
    corporate: function(){
      if (this.GroupID == 4)
      {
        return this.corporateRaw.filter((i)=>{
          return i.UpperID == 0
        })

      } else {
        return this.corporateRaw
      }

    }
  },
  watch: {
    GroupID() {
      this.EnterpriseID = ""
    }
  },
  data() {
    return {
      UserType: [
        {
          id: 3,
          name: "Dtac Admin"
        },
        {
          id: 1,
          name: "Read Only"
        },
        {
          id: 2,
          name: "Enterprise Admin"
        },
        {
          id: 4,
          name: "Enterprise Super Admin"
        }
      ],

      Username: "",
      Name: "",
      Email: "",
      Phone: "",
      GroupID: 2,
      EnterpriseID: ""
    };
  },
  mounted() {
    this.listCorporate();
  },
  methods: {
    ...mapActions({
      createData: "Auth/createData",
      updateData: "Auth/updateData",
      deleteData: "Auth/deleteData",
      listData: "Auth/listData",
      listCorporate: "Corporate/listData"
    }),
    generatePassword(length = 8) {
      // Exclude easily-confused characters (0/O, 1/l/I) since the
      // password is emailed to the user to type in manually.
      const charset =
        "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
      // Reject bytes above the largest multiple of charset length
      // to avoid modulo bias.
      const max = 256 - (256 % charset.length);
      let out = "";
      while (out.length < length) {
        const bytes = window.crypto.getRandomValues(
          new Uint8Array(length * 2)
        );
        for (const b of bytes) {
          if (b < max && out.length < length) {
            out += charset[b % charset.length];
          }
        }
      }
      return out;
    },
    handleCreate() {
      this.createData({
        username: this.Username,
        email: this.Email,
        name: this.Name,
        groupID: this.GroupID,
        enterpriseID: this.EnterpriseID,
        password: this.generatePassword(),
        phone: this.Phone,
        status: 1
      })
        .then(resp => {
          console.log(resp);
          swal
            .fire({
              title: this.$t("user.create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              this.$router.push({ name: "user" });
            });
        })
        .catch(err => {
          console.log(err);
          // show error
          swal.fire({
            title: this.$t(err.response.data.Msg),
            icon: "error",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-info btn-fill"
          });
        });
    },
    filesChange(files) {
      this.inputs.file = files;
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
